import { GeneratePDFDef } from "../../type/report/generate-pdf";

export class GeneratePDFAdapter {
  static toInputDTO(): any {
    return {
    };
  }

  static toOutputDTO(res: any): GeneratePDFDef {
    return res;
  }
}
